import { AnyUser } from "@megaron/access-control";
import { diffSyncActions } from "@megaron/diff-sync-contracts";
import { HttpService } from "@megaron/http-service";
import { HandlerMap } from "@megaron/http-service-host";

import { catalogDiffSyncSchema } from "./diffSync";
import { itemsActions } from "./items";

export const catalogHttpService = HttpService({
  ...itemsActions,
  ...diffSyncActions(catalogDiffSyncSchema),
});

export type CatalogHandlers = HandlerMap<typeof catalogHttpService, AnyUser>;
